<template>
	<PCard class="min-h-screen">
		<template #title>
			<div class="flex align-items-center justify-content-between">
				<WTitle text="Logs" />
			</div>
		</template>
		<template #content>
			<PDataTable
				:alwaysShowPaginator="false"
				:highlightOnSelect="true"
				:loading="loading"
				:resizableColumns="true"
				:rowHover="true"
				:rows="300"
				:rowsPerPageOptions="[300, 500, 1000]"
				:sortOrder="-1"
				:stripedRows="true"
				:value="list"
				data-key="pid"
				paginator
				paginatorPosition="both"
				size="small"
				sortField="time"
			>
				<template #empty>No records found.</template>

				<PColumn
					bodyClass="text-left vertical-align-top py-0"
					class="justify-content-center"
					field="time"
					header="Time"
					style="width: 230px"
				></PColumn>
				<PColumn
					bodyClass="text-left vertical-align-top py-0"
					class="justify-content-center"
					field="user"
					header="User"
					style="width: 100px"
				></PColumn>
				<PColumn
					bodyClass="text-left vertical-align-top text-wrap py-0"
					class="justify-content-center"
					field="message"
					header="Message"
				></PColumn>
			</PDataTable>
		</template>
	</PCard>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Utils from '@/utils/Utils'
	import Constants from '@/helpers/Constants'
	import BEBroker from '@/brokers/BEBroker'

	export default defineComponent({
		name: 'LogsView',
		components: {
		},

		data() {
			return {
				utils: Utils,
				component: 'logs',
				loading: true,
				list: [],
			}
		},


		async mounted() {
			Utils.generatePid(Constants.OPID.READ)
			await this.refreshList()
			this.loading = false
		},


		methods: {

			/**
			 * Refresh the items list
			 */
			async refreshList() {
				const res = await BEBroker.get(this.component)
				if (res !== null) {
					this.list = res.map((item: String) => {
						const parts = item.split(' - ')
						return {
							time: parts[0],
							pid: parts[1],
							user: parts[2],
							message: parts[3],
						}
					})
				} else {
					return {}
				}
			},
		}




	})
</script>
